import { BaseType } from '../../../base/base-type';

export class EmploymentStatusChangeDefinitionType extends BaseType {
  public definition!: string;
  public htmlDefinition!: string;
}
